export const environment = {
  production: false,
  
  // Backend URLs
  apiUrl: '/cas-api',  // Spring Boot Backend (CAS) via Angular proxy in local
  flaskUrl: '/flask-api', // Flask Backend (CAC) via Angular proxy in local
  
  apiEndpoint: '/api',
  baseHref: '/',
  enableLogging: true,
  enableDebugTools: true,
  
  // Endpoints Spring Boot (Port 8081) - Tarification et Devis
  endpoints: {
    
    // Alptis
    alptis: {
      tarification: '/api/v1/tarification/alptis',
      offres: '/api/v1/tarification/alptis/offres',
      devis: '/api/v1/tarification/alptis/devis/generer-pdf',
      devisTest: '/api/v1/tarification/alptis/devis/generer-pdf-test',
      santeProPlus: '/api/alptis/sante-pro-plus/tarification',
      lumineis: '/api/v1/alptis/lumineis/tarification'
    },
    
    // Apivia
    apivia: {
      tarification: '/api/v1/tarification/apivia',
      produits: '/api/v1/tarification/apivia/produits',
      devis: '/api/apivia/generate-devis'
    },
    
    // April
    april: {
      projects: '/api/v1/comparisons/april/projects/prices'
    },
    
    // Generali
    generali: {
      tarification: '/api/v1/generali/tarification',
      compositions: '/api/v1/generali/compositions',
      formules: '/api/v1/generali/formules',
      santePro: {
        tarification: '/api/v1/generali/sante-pro/tarification',
        formules: '/api/v1/generali/sante-pro/formules',
        compositions: '/api/v1/generali/sante-pro/compositions',
        zones: '/api/v1/generali/sante-pro/zones'
      }
    },
    
    // 2MA (Acheel, 3CAO, 2Maltitude)
    deuxma: {
      acheel: '/api/deuxma/v1/tarifs/acheel',
      troiscao: '/api/deuxma/v1/3cao/tarification',
      troiscaoDevis: '/api/deuxma/v1/3cao/devis',
      deuxmaltitude: '/api/deuxma/v1/2maltitude/tarification',
      deuxmaltitudeDevis: '/api/deuxma/v1/2maltitude/devis'
    },
    
    // Utwin
    utwin: {
      tarification: '/api/utwin/tarification'
    }
  },
  
  // Endpoints Flask (Port 5000) - Comparateur uniquement
  flaskEndpoints: {
    comparateur: '/compare',
    contracts: '/api/contracts'
  }
};